import {$, cabtv_wp_request, Cookies} from "./core.js";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import {debounce_next_frame} from "livestreamer/utils/dom/debounce_next_frame.js";
import {DropdownMenu} from "livestreamer/utils/dom/DropdownMenu.js";
import {clamp} from "livestreamer/utils/clamp.js";
import {EventEmitter} from "livestreamer/utils/EventEmitter.js";
import "bootstrap/js/dist/collapse.js";
import "bootstrap/js/dist/dropdown.js";
import {default as BootstrapTooltip} from "bootstrap/js/dist/tooltip.js";
import ResizeObserver from 'resize-observer-polyfill';
import 'intersection-observer';

// import tippy from 'tippy.js';
// import "bootstrap/dist/css/bootstrap.css";
import "tippy.js/dist/tippy.css";
import "./front.scss";
// import fred_svg_raw from "./assets/fred.svg?raw";

console.log("CABTV");

export let MIN_GALLERY_ITEM_SIZE = 300;
export let FETCH_ANNOUNCEMENTS_INTERVAL = 30*1000;

/* window.getSubscriptionState = function() {
    return Promise.all([
        OneSignal.isPushNotificationsEnabled(),
        OneSignal.isOptedOut()
    ]).then(function(result) {
        let isPushEnabled = result[0];
        let isOptedOut = result[1];
        let s = {
            isPushEnabled: isPushEnabled,
            isOptedOut: isOptedOut
        };
        console.log(s);
        return s;
    });
} */

/* export let webp_promises = {};
export async function check_webp_feature(feature="alpha") {
    if (!webp_promises[feature]) {
        webp_promises[feature] = new Promise((resolve)=>{
            let kTestImages = {
                lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
                lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
                alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
                animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
            };
            let img = new Image();
            img.onload = ()=>resolve(img.width > 0 && img.height > 0);
            img.onerror = ()=>resolve(false);
            img.src = "data:image/webp;base64," + kTestImages[feature];
        });
    }
    return webp_promises[feature];
} */

class GalleryItem {
    index = -1;
    el;
    src;
    thumb;
    caption;
    type;

    /** @param {Gallery} parent @param {HTMLElement|string} el */
    constructor(parent, el) {
        this.parent = parent;
        this.responsive_image = ResponsiveImage.resolve(el);
        if (typeof el === "string") {
            this.src = el;
        } else if (el instanceof HTMLIFrameElement || el instanceof HTMLEmbedElement) {
            this.el = el;
            this.src = el.src;
            this.type = "iframe";
        } else if (el instanceof HTMLImageElement || el instanceof HTMLVideoElement) {
            this.el = el;
            let figure = this.el.closest("figure");
            if (figure) {
                let figcaption = figure.querySelector("figcaption");
                if (figcaption) this.caption = figcaption.innerText;
            }
            let srcset = [];
            let picture = this.el.closest("picture");
            if (picture) {
                for (let source of picture.querySelectorAll("source")) {
                    srcset.push(...source.srcset.split(/,\s*/));
                }
            }
            srcset.push(...String(el.dataset.srcset || el.srcset || "").split(/,\s+/).filter(s=>s));
            srcset.sort((a,b)=>{
                let [a_url, a_size] = a.split(/\s+/);
                let [b_url, b_size] = b.split(/\s+/);
                return parseFloat(a_size) - parseFloat(b_size);
            });
            let srcset_urls = srcset.map(s=>s.split(/\s+/)[0]);

            this.src = el.dataset.originalSrc || el.dataset.originalSrc || this.el.src;
            this.thumb = srcset_urls[0] || this.src;
            // this.thumb = this.el.currentSrc || this.src || this.el.src;
            
            if (el instanceof HTMLVideoElement) {
                this.is_video = true;
                this.thumb = el.poster || captureFirstFrame(el.src);
            }
        }
            
        if (!this.el.closest("a")) {
            let a = document.createElement("a");
            a.href = this.src;
            el.parentElement.insertBefore(a, el);
            a.appendChild(el);
            a.onclick = (e)=>{
                e.preventDefault();
                this.parent.open(this.parent.item_map[this.src].index);
            };
            this.trigger_el = a;
        }
        
    }
    async to_fancybox_item() {
        var ob = {
            triggerEl: this.trigger_el,
            src: this.src,
            caption: this.caption,
            type: this.type,
            thumbSrc: await this.thumb,
            thumbEl: this.el,
        }
        // Fancybox is weird, shows a null image because it detects a video if we use the other way:
        /* if (this.is_video) {
            ob.thumb = await this.thumb;
        } else{
            // ob.thumb = await this.thumb;
            ob.thumbEl = this.el;
            ob.thumbSrc = await this.thumb;
        } */
        return ob;
    }
}
export class Gallery {
    /** @type {GalleryItem[]} */
    items = [];
    /** @type {Record<string, GalleryItem>} */
    item_map = {};

    constructor(name, els) {
        this.name = name || "gallery";
        for (let el of els) {
            let item = new GalleryItem(this, el);
            if (this.item_map[item.src]) Object.assign(this.item_map[item.src], item);
            else {
                item.index = this.items.length;
                this.items.push(item);
                this.item_map[item.src] = item;
            }
        }
    }
    async open(index = 0) {
        let items = await Promise.all(this.items.map(item=>item.to_fancybox_item()));
        let fb = Fancybox.show(items, {
            startIndex:index,
            // zoomEffect: true,
            Carousel : {
                Thumbs: {
                    showOnStart: true,
                    type: "modern",
                },
                // Zoomable: {
                //     Panzoom : {
                //         minScale: "full"
                //     }
                // }
            },
        });
        fb.on("done", ()=>{
            let slide = fb.getSlide();
            // let item = this.items[slide.index];
            /** @type {HTMLVideoElement} */
            let video = slide.contentEl.querySelector("video");
            let item = this.items[slide.index];
           /*  if (item.is_video) {
                slide.contentEl.classList.add("is-video-like");
            } */
            if (video) {
                video.autoplay = item.el.autoplay;
                video.loop = item.el.loop;
                video.muted = item.el.muted;
            }
        });
    }
};

export class SiteNavigation {
    get is_sticky() { return this.#is_sticky; }
    #is_sticky = false;

    #disable_sticky = false;
    #wpadmin_bar;
    #fadeout_timeout;
    #last_scroll = 0;
    #height = 0;
    get height() { return this.#height; }

    disable_sticky() { this.#disable_sticky = true; this.#update_sticky(); }

    /** @param {HTMLElement} el */
    constructor(el) {
        this.el = el;
        this.#wpadmin_bar = document.querySelector("#wpadminbar");
        let fadeout_timeout;
        let dropdown_els = el.querySelectorAll('.dropdown');
        for (let dropdown_el of dropdown_els) {
            var get_dropdown_menu = (id)=>document.querySelector(`[aria-labelledby="${id}"]`);
            $(dropdown_el).on("click", (e)=>{
                let menu = get_dropdown_menu(e.target.id);
                if (menu && menu.contains(e.target)) e.stopPropagation();
            });
            $(dropdown_el).on('show.bs.dropdown', (e)=>{
                let menu = get_dropdown_menu(e.target.id);
                $(menu).stop(true, true).slideDown(300);
            });
            $(dropdown_el).on('hide.bs.dropdown', (e)=>{
                let active = document.activeElement;
                let menu = get_dropdown_menu(e.target.id);
                $(menu).stop(true, true).slideUp(300);
                requestAnimationFrame(()=>{
                    // crazy bootstrap quirk, steals focus on close, wtf.
                    if (document.activeElement == dropdown_el) document.activeElement.blur();
                    if (active != dropdown_el && !dropdown_el.contains(active)) active.focus();
                });
            });
        }
    
        $(el).on("show.bs.collapse", (e)=>{
            el.classList.add("open");
        });
    
        $(el).on("hide.bs.collapse", ()=>{
            el.classList.remove("open");
           this.#fadeout_sticky();
        });

        window.addEventListener("resize", ()=>{
            this.#update_sticky(true);
        });
        document.addEventListener("scroll", ()=>{
            this.#update_sticky();
            this.#last_scroll = document.scrollingElement.scrollTop;
        });
        this.#update_sticky();
    }
    
    #fadeout_sticky() {
        clearTimeout(this.#fadeout_timeout);
        this.#fadeout_timeout = setTimeout(()=>{
            let has_focus = this.el === document.activeElement || this.el.contains(document.activeElement);
            if (has_focus) return;
            this.el.classList.toggle("visible", false);
            if (this.#is_sticky && has_focus) {
                document.activeElement.blur();
            }
        }, 2000);
    };

    #update_sticky(force=false){
        let r = this.el.getBoundingClientRect();
        let top = 0;
        let height = r.height;
        if (this.#wpadmin_bar) {
            let r = this.#wpadmin_bar.getBoundingClientRect();
            if (r.top >= 0) {
                top = Math.max(0, r.bottom);
                height += r.height;
            }
        }
        this.#is_sticky = r.top <= top && !this.#disable_sticky;
        this.#height = height;
        this.el.classList.toggle("is-sticky", this.#is_sticky);
        // document.documentElement.style.setProperty("--sticky-height", `${height}px`);

        //todo: figure out better way to handle sticky header
        if (this.#is_sticky) {
            this.el.style.top = `${top}px`;
            let deltaY = document.scrollingElement.scrollTop - this.#last_scroll;
            if (deltaY != 0 || force) {
                this.el.classList.toggle("visible", true);
                this.#fadeout_sticky();
            }
        } else {
            this.el.style.top = `0px`;
        }
    };
}

/** @typedef {{url:string, desc:string}} Source */

class ResponsiveImageSource {
    /** @param {ResponsiveImage} parent @param {string} url @param {string} desc @param {string} type */
    constructor(parent, url, desc, type) {
        this.parent = parent;
        this.url = url;
        this.desc = desc || "1x";
        this.type = type;
    }
    get width() {
        let desc = this.desc;
        let m = desc.match(/(\d+)(x|w)/);
        let dd = +m[1];
        let suffix = m[2];
        if (suffix === "x")  return dd * +this.parent.width;
        if (suffix === "w") return dd;
        throw new Error(`Invalid descriptor: ${desc}`);
    }
    get height() {
        return this.width / this.parent.aspect_ratio;
    }
}
export class ResponsiveImage {
    /** @type {ResponsiveImageSource[]} */
    srcs = [];
    src_map = {};
    current_src_url;
    width;
    height;
    get aspect_ratio() { return this.width / this.height; }
    get current_src() { return this.src_map[this.current_src_url]; }

    /** @param {HTMLElement} el */
    constructor (el) {
        this.el = el;
        /** @type {HTMLImageElement} */
        this.img = [...el.children].filter(c=>c.tagName == "IMG")[0] || document.createElement("img");
        if (!this.img.parentElement) el.append(this.img);
        this.el.__responsive__ = this;
        this.img.__responsive__ = this;
        this.width = +this.img.getAttribute("width");
        this.height = +this.img.getAttribute("height");
        // this.add_source(this.img.dataset.src);
        this.original_src = this.img.src;
        let srcset = this.el.dataset.srcset || this.img.dataset.srcset || this.img.srcset;
        this.img.removeAttribute("srcset");
        this.img.removeAttribute("sizes");
        for (let src of srcset.split(/,\s*/)) {
            this.add_source(src);
        }
        let picture = this.img.closest("picture");
        if (picture) {
            for (let source of picture.querySelectorAll("source")) {
                elems.push(source);
                for (let src of source.srcset.split(/,\s*/)){
                    this.add_source(src, source.type);
                }
            }
        }
        if (!this.srcs.length) {
            let src = [this.img.src];
            var w = this.img.getAttribute("width");
            if (w) src.push(`${w}w`);
            this.add_source(src.join(" "));
        }

        this.observer = new ResizeObserver(()=>this.update());
        this.observer.observe(this.el);

        this.iobserver = new IntersectionObserver(()=>this.update());
        this.iobserver.observe(this.el);

        this.update();
    }

    /** @param {HTMLImageElement} el @returns {ResponsiveImage} */
    static resolve(el) {
        el = el.closest(".responsive-image") || el;
        return el.__responsive__ || new ResponsiveImage(el);
    }

    add_source(url_desc, type) {
        if (!url_desc) url_desc = "";
        url_desc = url_desc.trim();
        if (!url_desc) return;
        let [url, desc] = url_desc.split(/\s+/);
        let src = new ResponsiveImageSource(this, url, desc, type);
        if (this.src_map[url]) Object.assign(this.src_map[url], src);
        else {
            this.srcs.push(src);
            this.srcs.sort((a,b)=>a.width - b.width);
            this.src_map[url] = src;
        }
        this.update_srcs();
    }

    is_visible() {
        let { top, left, right, bottom } = this.img.getBoundingClientRect();
        let [wtop, wleft, wright, wbottom] = [0, 0, window.innerWidth, window.innerHeight];
        wtop -= window.innerHeight;
        wbottom += window.innerHeight;
        return ((top >= wtop && top <= wbottom) || (bottom >= wtop && bottom <= wbottom)) && ((left >= wleft && left <= wright) || (right >= wleft && right <= wright));
    }

    update = debounce_next_frame(this.#update);
    update_srcs = debounce_next_frame(this.#update_srcs);

    #update_srcs() {
        // this serves no purpose except for debugging.
        // this.el.dataset.srcset = this.srcs.map(s=>`${s.url} ${s.desc}`).join(", ");
        // this.el.dataset.originalSrc = this.original_src;
    }

    #update() {
        let p = window.devicePixelRatio;
        let w = this.img.offsetWidth * p;
        let h = this.img.offsetHeight * p;
        var object_fit = this.el.dataset.objectFit || "contain";
        var aspect_ratio = this.aspect_ratio;
        
        if (object_fit == "contain" && aspect_ratio) {
            if (w > h) {
                w = h * aspect_ratio;
            } else {
                h = w / aspect_ratio;
            }
        }
        if (!this.srcs.length || !w || !h || !this.is_visible()) return;
        
        this.img.classList.add("visible");
        let src;
        for (src of this.srcs) {
            if (src.width >= w && src.height >= h) break;
        }
        if (!src) return;
        if (this.current_src && src.width < this.current_src.width) return;
        if (this.current_src_url != src.url) {
            this.current_src_url = src.url;
            var old_img = this.img;
            this.img = old_img.cloneNode();
            var new_img = this.img;
            new_img.style.position = "absolute";
            new_img.style.top = "0";
            new_img.style.left = "0";
            new_img.classList.remove("loaded");
            new_img.src = this.current_src_url;
            new_img.style.filter = ``;
            new_img.__responsive__ = this;
            var remove = ()=>{
                new_img.style.position = "relative";
                new_img.style.top = "";
                new_img.style.left = "";
                if (old_img.parentElement) old_img.remove();
            }
            new_img.onload = ()=>{
                new_img.classList.add("loaded");
                setTimeout(remove, 500);
            };
            old_img.parentElement.append(new_img);
        }
    }
}

{
    let process_node = (el)=>{
        if (el.matches(".responsive-image")) {
            ResponsiveImage.resolve(el);
        } else {
            for (let c of el.querySelectorAll(".responsive-image")) {
                ResponsiveImage.resolve(c);
            }
        }
    };
    let observer = new MutationObserver((mutations) => {
        for (let m of mutations) {
            for (let n of m.addedNodes) {
                if (!(n instanceof HTMLElement)) continue;
                process_node(n);
            }
        }
    });
    observer.observe(document.documentElement, {childList: true, subtree: true });
    process_node(document.documentElement);
}

export class CABTVFrontApp extends EventEmitter {
    #next_announcements_timeout;
    #last_announcements_html;

    path;
    profile_url;
    account_url;
    logout_url;
    login_url;
    register_url;
    /** @type {{data:{user_nicename:string}}} */
    user;
    template_url = "";
    /** @type {{root:string, nonce:string}} */
    wp_rest_settings;
    /** @type {{is_logged_in:boolean, is_live:boolean, is_live_visible:boolean, is_go_lives_visible:boolean, is_private_live:boolean, is_private_go_lives:boolean}} */
    live;
    /** @type {{key:string, main_url:string}} */
    livestreamer_config;
    /** @type {{app_id:string, safari_web_id:string}} */
    onesignal;

    constructor() {
        super();
        Object.assign(this, window.cabtv || {});

        this.announcements_wrapper_el = document.querySelector(`#announcements-bar`);
        this.announcements_el = document.querySelector("#announcements");
            
        for (let form of document.querySelectorAll("form")) {
            // so fucking DUMB, wordpress wtf.
            form.removeAttribute("novalidate");
        }
       
        window.OneSignalDeferred = window.OneSignalDeferred || [];
        OneSignalDeferred.push(async function(OneSignal) {
            var serviceWorkerPathDir = new URL(cabtv.template_url).pathname;
            await OneSignal.init({
                appId: cabtv.onesignal.app_id,
                safari_web_id: cabtv.onesignal.safari_web_id,
                notifyButton: {
                    enable: !window.location.pathname.match(/^\/live\//),
                    position: 'bottom-left',
                    showCredit: false,
                },
                allowLocalhostAsSecureOrigin: true,
                serviceWorkerPath: `${serviceWorkerPathDir.slice(1)}/OneSignalSDKWorker.js`,
                serviceWorkerParam: {
                    scope: `${serviceWorkerPathDir}/`
                }
            });
        });

        this.nav = new SiteNavigation(document.querySelector(`#site-navigation`));

        let is_logged_in = document.body.classList.contains("logged-in");
        let profile_img_els = document.querySelectorAll(".profile-img");
        for (let profile_img_el of profile_img_els) {
            let tippy_opts = {
                theme: "profile-menu",
                placement: "bottom",
                arrow: true,
            };
            let dropdown = new DropdownMenu({
                target: profile_img_el,
                trigger: "click",
                items: is_logged_in ? [
                    {
                        "label":"Profile",
                        "icon": `<i class="fas fa-user"></i>`,
                        "href": window.cabtv.profile_url,
                    },
                    {
                        "label":"Account",
                        "icon": `<i class="fas fa-cog"></i>`,
                        "href": window.cabtv.account_url,
                    },
                    {
                        "label":"Log out",
                        "icon": `<i class="fas fa-right-from-bracket" style="transform: scaleX(-1);"></i>`,
                        "href": window.cabtv.logout_url,
                    }
                ] : [
                    {
                        "label":"Login",
                        "icon": `<i class="fas fa-right-from-bracket"></i>`,
                        "href": window.cabtv.login_url
                    },
                    {
                        "label":"Register",
                        "icon": `<i class="fas fa-user-plus"></i>`,
                        "href": window.cabtv.register_url,
                    }, 
                    {
                        "align": "center",
                        "label":"???",
                        "click": async()=>{
                            let $el = $(`<div style="background:black; position:fixed; z-index:9999; left:0; top:0;width:100%; height:100%"><video style="width:100%; height:100%; object-fit:contain;" src="${cabtv.template_url}/video/whoami.mp4" playsinline></video></div>`);
                            $(document.body).append($el);
                            let video = $el.find("video")[0];
                            await Promise.all([
                                $el.hide().fadeIn(1000).promise(),
                                new Promise(resolve=>video.addEventListener('canplaythrough', resolve))
                            ]);
                            try {
                                video.play();
                            } catch (e) {
                                console.error(e);
                            }
                            await new Promise(resolve=>video.addEventListener('ended', resolve));
                            await $el.fadeOut(1000).promise();
                            $el.remove();
                        }
                    }
                ],
                tippy_opts
            });
            /* if (!is_logged_in) {
                let dropdown2 = new DropdownMenu({
                    target: profile_img_el,
                    trigger: "contextmenu",
                    items: [
                        {
                        }
                    ],
                    tippy_opts
                });
            } */
            /* document.addEventListener("scroll", (e)=>{
                dropdown.toggle(false);
            }); */
        }

        if (document.body.classList.contains("home")) {
            let copyright = document.querySelector(".copyright");
            copyright.onclick = async ()=>{
                copyright.innerHTML = `<div style="height=300px;"><img src='${cabtv.template_url}/images/jesus.gif' style="transform:scale(0);opacity:0;"></img></div>`;
                copyright.onclick = null;
                copyright.style.cursor = "";
                await $('html, body').animate({
                    scrollTop: document.body.scrollHeight
                }, 500).promise();
                let img = copyright.querySelector("img");
                $(img)
                    .animate({
                        'opacity': 1
                        }, {
                        step: function(now) {
                            $(this).css('transform', 'scale(' + now + ')');
                        }
                    });
            }
            copyright.style.cursor = "pointer";
        }

        for (let a of document.querySelectorAll("#menu-social-menu a")) {
            a.setAttribute("data-bs-toggle", "tooltip");
            a.setAttribute("title", a.textContent);
        }

        if (document.body.classList.contains("single-post")) {
            let content = document.querySelector(`article .entry-content`);
            let medias = content ? [...content.querySelectorAll(`img:not(.emoji), video, .wp-block-embed.is-type-video iframe`)] : [];
            let gallery = new Gallery("gallery", medias);
            if (gallery.items.length) {
                let parent = document.querySelector(".meta-wrapper");
                let gallery_open = $(`<span class='gallery-open-wrapper'><a class='button small gallery-open' href='#gallery' title="Open Gallery"><i class="fa-regular fa-images"></i> Gallery (${gallery.items.length})</a></span>`)[0];
                gallery_open.querySelector("a").onclick = (e)=>{
                    e.preventDefault();
                    gallery.open();
                };
                parent.append(gallery_open);
            }
        }

        if (document.body.classList.contains("single-show")) {
            let show_grid = document.querySelector(".show-grid");
            let load_more = document.querySelector("#load-more");

            let page = 1;
            load_more.onclick = async ()=>{
                load_more.disabled = true;
                let orig_html = load_more.innerHTML;
                load_more.innerHTML = `Loading... <i style="font-size:20px" class="fas fa-circle-notch fa-spin"></i>`
                let results = await cabtv_wp_request("GET", "get_show_thumbnails", {
                    'id' : this.get_post_id(),
                    'page' : ++page,
                });
                if (results.success) {
                    show_grid.append(...$(results.thumbnails.html));
                    load_more.disabled = false;
                    load_more.innerHTML = orig_html;
                    load_more.style.display = results.thumbnails.pages == results.thumbnails.page ? "none" : "";
                }
            };
        }
        
        var toggle_darkmode_transition_promise;
        document.addEventListener("click", (e)=>{
            if (e.target.closest("[data-toggle-lights]")) {
                toggle_darkmode_transition_promise = toggle_darkmode_transition_promise ?? toggle_darkmode_transition().finally(()=>{
                    toggle_darkmode_transition_promise = undefined;
                });
            }
        });
        var toggle_darkmode_transition = async ()=>{
            let el = $(`<div style="background:black; position:fixed; z-index:2147483647; left:0; top:0; width:100%; height:100%; pointer-events:none;"></div>`)[0];
            document.body.append(el);
            await $(el).hide().fadeIn(100).promise();
            this.toggle_darkmode();
            await $(el).fadeOut(200).promise();
            el.remove();
        }

        let sheen = (logo)=>{
            if (logo.querySelector(".sheen-effect")) return;
            let img = logo.querySelector("img");
            let src = img.src;
            let sheen = $(`<div class='sheen-effect'></div>`)[0];
            sheen.style.setProperty("--mask", `url(${src})`);
            sheen.style.width = `${img.offsetWidth}px`;
            sheen.style.height = `${img.offsetHeight}px`;
            sheen.style.left = `${img.offsetLeft}px`;
            sheen.style.top = `${img.offsetTop}px`;
            logo.append(sheen);
            logo.sheens = logo.sheens || 0;
            logo.sheens++;
            const destroy = ()=>{
                sheen.remove();
            }
            setTimeout(destroy, 2000);
            sheen.onanimationend = destroy;
        }

        let logos = document.querySelectorAll(".site-logo");
        for (let logo of logos) {
            logo.onpointerenter = ()=>{
                sheen(logo);
            };
        }
        /* setTimeout(()=>{
            if (!logos[0].sheens) sheen(logos[0]);
        }, 1500); */
        /* window.addEventListener("focus", ()=>{
            sheen(logos[0]);
        }) */

        /** @param {HTMLAnchorElement} a */
        let fix_anchor = (a)=>{
            try {
                // console.log(a.href);
                if (a.href.match(/https?:\/\//)) {
                    let url = new URL(a.href);
                    if (url.host != window.location.host) {
                        if (!a.target) a.target = "_blank";
                    }
                }
            } catch {}
        }

        /** @type {Record<PropertyKey, function(Element)>} */
        let mutators = {
            "a":(a)=>{
                fix_anchor(a)
            }
        }

        for (let k in mutators) {
            document.querySelectorAll(k).forEach(a=>mutators[k](a));
        }

        let mObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        for (let k in mutators) {
                            if (node instanceof Element) {
                                if (node.matches(k)) mutators[k](node);
                                node.querySelectorAll(k).forEach(e=>mutators[k](e));
                            }
                        }
                    })
                }
            })
        });
        mObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        this.darkmode = !!(Cookies.get("darkmode") == 1 || window.matchMedia("(prefers-color-scheme:dark)").matches);
        this.is_halloween = document.body.classList.contains("is-halloween");
        this.is_christmas = document.body.classList.contains("is-christmas");
        this.toggle_darkmode(this.darkmode);
        
        /* if (window.cabtv.media) {
            for (let m of Object.values(window.cabtv.media)) {
                m.files = Object.values(m.files).sort((a,b)=>{
                    let a_size = a.meta.width*a.meta.height;
                    let b_size = b.meta.width*b.meta.height;
                    return b_size-a_size;
                });
            }
        } */
       this.init_bs_tooltips();
        
       window.addEventListener('pageshow', function(event) {
           // Check if this is a page restored from the back/forward cache
           if (event.persisted) {
                // Reset all form elements
                document.querySelectorAll('input, select, textarea').forEach(element => {
                    element.value = element.getAttribute("value") || "";
                });
           }
       });

       this.update_announcements(this.announcements_el.innerHTML);
       this.#setup_next_fetch_announcements();
    }

    init_bs_tooltips() {
        let tooltips = document.querySelectorAll("[data-bs-toggle=tooltip]");
        for (let tooltip of tooltips) {
            if (tooltip.dataset.bsOriginalTitle) continue;
            new BootstrapTooltip(tooltip, {
                trigger: "hover",
            });
        }
    }

    toggle_darkmode(value) {
        if (value === undefined) value = !this.darkmode;
        if (this.darkmode == value) return;
        this.darkmode = !!value;
        Cookies.set("darkmode", this.darkmode ? "1" : "0");
        document.body.dataset.darkmode = this.darkmode;
        console.log(`dark:`, this.darkmode);
    }

    toggle_halloween(value) {
        if (value === undefined) value = !this.halloween;
        value = !!value;

        if (this.halloween === value) return;

        this.halloween = value;
        Cookies.set("halloween", value ? "1" : "0");
        document.body.dataset.halloween = value;
    }
    
    get_post_id() {
        let m;
        [...document.body.classList].find((c)=>m = c.match(/^postid-(.+)$/));
        if (m) return m[1];
    }

    debounced_update_announcements = debounce_next_frame(()=>this.update_announcements());

    update_announcements(html) {
        
        if (this.#last_announcements_html == html) return;

        this.#last_announcements_html = html;
        this.announcements_el.innerHTML = html;
        this.announcements_el.dataset.index = 0;

        var buttons = [...this.announcements_wrapper_el.querySelectorAll("button")];
        if (!buttons.length) {
            buttons[0] = $(`<button><i class="fas fa-chevron-left"></i></button>`)[0];
            buttons[1] = $(`<button><i class="fas fa-chevron-right"></i></button>`)[0];
            this.announcements_wrapper_el.prepend(buttons[0]);
            this.announcements_wrapper_el.append(buttons[1]);
            buttons[0].onclick = ()=>update_index(+this.announcements_el.dataset.index-1);
            buttons[1].onclick = ()=>update_index(+this.announcements_el.dataset.index+1);
        }
        
        let update_index = (index)=>{
            let num_announcments = this.announcements_el.childElementCount;
            let last = Math.max(num_announcments-1, 0);
            index = clamp(index, 0, last);
            this.announcements_el.dataset.index = index;
            this.announcements_el.style.left = `-${index*100}%`;
            buttons[0].disabled = index == 0;
            buttons[1].disabled = index == last;
            buttons.forEach(b=>b.style.display = num_announcments>1?"":"none");
        }

        update_index(0);
    }
        
    async fetch_announcements() {
        let res = await cabtv_wp_request("GET", "get_live_data");

        if (!res.success) return;

        let live_data = res.live_data;

        if (window.cabtv.live.is_live_visible && !live_data.is_live_visible) {
            window.location.reload();
            return;
        }

        Object.assign(window.cabtv.live, live_data);
        for (let k in live_data) {
            if (typeof live_data[k] === "boolean") {
                document.body.classList.toggle(k, live_data[k]);
            }
        }
        
        this.update_announcements(live_data.announcements_html);
        this.#setup_next_fetch_announcements();
    }

    #setup_next_fetch_announcements() {
        clearTimeout(this.#next_announcements_timeout);
        this.#next_announcements_timeout = setTimeout(()=>{
            this.fetch_announcements();
        }, FETCH_ANNOUNCEMENTS_INTERVAL);
    };

    async halloween_bat_swarm(count) {
        var pumpkin = document.querySelector("button.pumpkin");
        this.spin_animation(pumpkin.firstElementChild);
        const BatSwarm = (await import("./halloween_bat_swarm.js")).default;
        const bats = new BatSwarm();
        bats.spawnSwarm(count);
    }

    spin_animation(target) {
        $(target).css('transition', 'none')
            .css('transform', 'rotate(0deg)');
        setTimeout(()=>{
            $(target).css({
                transition: 'transform 600ms ease',
                transform: 'rotate(360deg)'
            });
        }, 1);
    }
}
/** @param {HTMLVideoElement} videoElement @param {HTMLCanvasElement} canvasElement */
async function captureFirstFrame(src) {
    const video = document.createElement('video');
    const canvas = document.createElement('canvas');
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.src = src;
    video.load();
    await new Promise((resolve, reject)=>{
        video.addEventListener('canplay', resolve);
        video.addEventListener('error', reject);
    });
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
        
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    
    return canvas.toDataURL();
}

export const app = window.cabtv = new CABTVFrontApp();